import { render, staticRenderFns } from "./wavierview.vue?vue&type=template&id=3848c449&scoped=true&"
import script from "./wavierview.vue?vue&type=script&lang=js&"
export * from "./wavierview.vue?vue&type=script&lang=js&"
import style0 from "./wavierview.vue?vue&type=style&index=0&id=3848c449&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3848c449",
  null
  
)

export default component.exports